import { formatDateDefault, formatTime24Hour, formatTimeSpanNormal, HostContext, HostContextValue } from "@buzzeasy/shared-frontend-utilities";
import { Alert, message, notification } from "antd";
import { useMemo } from "react";
import appTheme from "./appTheme";
import MainContainer from "./components/containers/MainContainer";
import Providers from "./components/providers/Providers";
import environmentConfig from "./environmentConfig";
import GlobalStyle from "./GlobalStyle";

const { useMessage } = message;
const { useNotification } = notification;

const { apiBaseUrl } = environmentConfig;

const queryParameters = new URLSearchParams(window.location.search);
const conversationId = queryParameters.get("conversationId");

function App() {
  const [messageApi, messageContextHolder] = useMessage();
  const [notificationApi, notificationContextHolder] = useNotification();

  const hostContextValue = useMemo<HostContextValue>(
    () => ({
      apiBaseUrl,
      token: "", // not used
      theme: appTheme.light,
      language: "en-US",
      isWindowFocused: true,
      displaySettings: {
        hideSensitiveAgentInformation: false,
        hideExternalContacts: false,
      },
      messageApi,
      notificationApi,
      formattingApi: {
        formatDate: formatDateDefault,
        formatTime: formatTime24Hour,
        formatDateTime: (date: Date) => `${formatDateDefault(date)} ${formatTime24Hour(date)}`,
        formatTimeSpan: formatTimeSpanNormal,
      },
    }),
    [messageApi, notificationApi],
  );

  if (!conversationId) {
    // eslint-disable-next-line @stylistic/jsx-one-expression-per-line
    return <Alert showIcon type="error" message={<>No <code style={{ fontWeight: "bold" }}>conversationId</code> search parameter was provided in the URL.</>} />;
  }

  return (
    <HostContext.Provider value={hostContextValue}>
      <Providers conversationId={conversationId}>
        <GlobalStyle />
        <MainContainer showHeader conversationId={conversationId} />
        {messageContextHolder}
        {notificationContextHolder}
      </Providers>
    </HostContext.Provider>
  );
}

export default App;
